import { render, staticRenderFns } from "./ClusterFunds.vue?vue&type=template&id=076c5fb5&scoped=true&"
import script from "./ClusterFunds.vue?vue&type=script&lang=js&"
export * from "./ClusterFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c5fb5",
  null
  
)

export default component.exports